import Tooltip from "rc-tooltip";
import React from "react";

export default function FixRouteBidBtn(props) {
    return (
        <div className="map-bid-legend">
            <Tooltip overlay="Сообщить о проблеме построения маршрута" placement="right">
                <div
                    className="map-bid-legend__button map-bid-legend__button--alert text-danger"
                    onClick={props.startSelectRange}
                />
            </Tooltip>
        </div>
    );
}
